import { cn } from "@/lib/style/cva.config";
import { formatDayMonth, formatWeekday } from "@/utils/format-datetime";

interface DateHeaderProps {
  date: Date;
  /** Tijdzone van het project. Standaard Europe/Amsterdam. */
  timeZone?: string | null;
  className?: string;
}

export function DateHeader({ date, timeZone, className }: DateHeaderProps) {
  // Altijd in projecttijd, nooit in de tijdzone van het toestel: anders leest de
  // kop boven de diensten van vrijdag "donderdag" op een telefoon die westelijk
  // van Greenwich staat.
  const formattedDayName = formatWeekday(date, { timeZone });
  const formattedDate = formatDayMonth(date, { timeZone });

  return (
    <h2 className={cn("py-2 text-md font-medium capitalize text-txt-tertiary", className)}>
      {formattedDayName}, {formattedDate}
    </h2>
  );
}
